<template>
  <div class="cashflow-loader">
    <div class="header-text">סיימנו! המערכת בונה את התזרים הראשון שלך...</div>
    <animated-loader/>
  </div>
</template>
<script>
import BaseUI from 'base-ui';
import Segment from '../../../../../../Segment';

export default {
  async created() {
    Segment.trackUserGot('CashflowLoaderEntered');
  },
  name: 'CashflowLoader',
  components: {
    AnimatedLoader: BaseUI.AnimatedLoader,
  },
};
</script>

<style lang="scss" scoped>

@import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../../../../../scss/mixins';

.cashflow-loader {
  height: 100%;
  @include white-page-frame;

  .header-text {
    color: $riseup_black;
    @include responsive-padding;
    @include responsive-padding-top-bottom;
    font-size: 22px;
    font-weight: bold;
    line-height: 1.27;
  }
}

</style>
